<template>
  <button
    class="icon-container"
    :disabled="isDisabled"
    @click="isDisabled ? null : emits('click')"
  >
    <img
      :width="size.width"
      :height="size.height"
      :src="src"
      :alt="alt"
      loading="lazy"
    />
  </button>
</template>

<script setup>
import { computed, ref } from "vue";

const props = defineProps({
  src: {
    type: String,
    default: undefined
  },
  alt: {
    type: String,
    default: undefined
  },
  width: {
    type: Number,
    default: undefined
  },
  height: {
    type: Number,
    default: undefined
  },
  isDisabled: {
    type: Boolean,
    default: false
  }
});

const emits = defineEmits(["click"]);

const size = computed(() => {
  const size = {};
  if (props.width) {
    size.width = props.width;
  } else {
    size.width = defaultSize.value;
  }
  if (props.height) {
    size.height = props.height;
  } else {
    size.height = defaultSize.value;
  }
  return size;
});

const defaultSize = ref(21);
</script>

<style scope lang="scss">
.icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  &[disabled] {
    opacity: 0.5;
    cursor: not-allowed;
  }
}
</style>
